import { Answers } from "../types/index";
import { AnswersInitConfig } from '../types/AnswersInitConfig';
import { AddComponentOptions } from '../types/AddComponentOptions';
import { defaultAnswersConfig, defaultSearchComponentConfig } from '../defaults';
import { constants } from "../constants";
import { assignDefined } from "@nbly/common"

export class SearchManager 
{
    private readonly answersScriptUrl = `https://assets.sitescdn.net/answers/v${constants.yextVersion}/answers.min.js`;
    private readonly answersCssUrl = `https://assets.sitescdn.net/answers/v${constants.yextVersion}/answers.css`;
    private answers: Answers | undefined;

    initSearchPage(config: Partial<AnswersInitConfig>, searchBarComponentOptions: AddComponentOptions)
    {
        this.appendCssRef();
        this.appendSearchScript(config, searchBarComponentOptions);
    }

    initResultsPage(config: { cdnPagesUrl: string })
    {
        this.appendResultIframeScript(config.cdnPagesUrl);
    }

    private appendSearchScript(config: Partial<AnswersInitConfig>, searchBarComponentOptions: AddComponentOptions)
    {
        const yextSearchScript = globalThis.document.createElement('script');

        yextSearchScript.src = this.answersScriptUrl;
        yextSearchScript.defer = true;
        yextSearchScript.async = true;
        yextSearchScript.addEventListener("load", () => 
        {
            const answers = globalThis["ANSWERS"] as Answers;
            this.answers = answers;

            answers.domReady(() =>
            {
                const mergedConfig = assignDefined(
                    {},
                    defaultAnswersConfig,
                    {
                        onReady: () =>
                        {
                            answers.addComponent(
                                "SearchBar",
                                assignDefined({}, defaultSearchComponentConfig, searchBarComponentOptions)
                            );
                        }
                    },
                    config
                ) as AnswersInitConfig;
                answers.init(mergedConfig);
            });
        });

        globalThis.document.head.appendChild(yextSearchScript);
    }

    private appendCssRef() 
    {
        const el = globalThis.document.createElement("link");
        el.rel = "stylesheet";
        el.type = "text/css";
        el.href = this.answersCssUrl;
        globalThis.document.head.appendChild(el);
    }

    private appendResultIframeScript(cdnPagesUrl: string) 
    {
        const iframeScript = globalThis.document.createElement("script");
        iframeScript.src = `${cdnPagesUrl}/iframe.js`;
        globalThis.document.head.appendChild(iframeScript);
    }
}